<template>
    <!-- Apply for PC or Laptop -->
    <v-container>
        <!-- List information -->
        <v-card class="pa-2" elevation="8">
        <v-list>
            <v-list-item-group>
            <v-list-item
                v-for="(item, index) in listSelectDiv"
                :key="item.code"
                @click="btnShow(item)"
                class="custom-list-item"
            >
                <v-list-item-icon>
                <v-icon color="primary">mdi-account-edit</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                    {{ item.name }}
                </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                <v-icon color="grey">mdi-chevron-right</v-icon>
                </v-list-item-action>
            </v-list-item>
            <!-- Chỉ hiển thị divider nếu không phải là phần tử cuối cùng -->
            <!-- <v-divider v-if="index !== listSelectDiv.length - 1"></v-divider> -->
            </v-list-item-group>
        </v-list>
        </v-card>
            <!-- Dialog Fullscreen -->
        <v-dialog v-model="showFullScreen" fullscreen persistent >
            <v-card>
                <v-toolbar dark color="green">
                <v-btn icon dark @click="showFullScreen = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ chooseDiv === true? selectTitle : selectDivision }}</v-toolbar-title>
                </v-toolbar>
                <v-sheet style="overflow-x: auto; overflow-y: auto" max-height="calc(100vh - 30px)">  
                <template>
                    <div class="w-container" v-if="selectDiv === '0'">
                        <v20a4000DockQuay ></v20a4000DockQuay>
                    </div>
                    <div class="w-container" v-if="selectDiv === '1'">
                        <v20a4000BlockYard 
                            @switchToProgress="selectDiv = '2'"
                            :data="blockData" 
                        ></v20a4000BlockYard>
                    </div>
                    <div class="w-container" v-if="selectDiv === '2'">
                        <v20a4000BlockProgress  
                            @switchToYard="switchToYard"                             
                        ></v20a4000BlockProgress>
                    </div>
                </template>
                </v-sheet>  
            </v-card>
        </v-dialog>  
    </v-container> 
</template>

<script>

import v20a4000BlockYard from './popup/v20a4000BlockYard'
import v20a4000DockQuay from './popup/v20a4000DockQuay'
import v20a4000BlockProgress from './popup/v20a4000BlockProgress'

export default {    
    name: "v20a4000",
    components: {
       v20a4000BlockYard,
       v20a4000DockQuay,
       v20a4000BlockProgress ,
    },
    props:{
    //    data: Object // Nhận dữ liệu từ `v20a4000.vue`
    },
    data: () => ({  
        showFullScreen: false,
        selectDiv: '0',
        selectedItem: {}, // Lưu item được chọn
        listSelectDiv: [
        {code: '0', name: 'Dock and Quay Schedule'},
        {code: '1', name: 'Yard Layout (Block Arrangement)'},
        {code: '2', name: 'Block progress monitoring'},
        ],
        blockData: null, // Tham số sẽ truyền qua Block Yard
        selectTitle: null,
        chooseDiv: false,
    }),   
    
    computed: {       

        isMobile() {
            return this.$vuetify.breakpoint.smAndDown; // Kiểm tra nếu là mobile
        },
        screenSize() {
            return this.$vuetify.breakpoint.name; // Lấy tên breakpoint hiện tại
        },
        selectDivision: function() {
            // console.log('selectDivision', this.selectTitle);
            const items = this.listSelectDiv.filter(item => item.code && item.code === this.selectedItem.code)
            return items.length > 0 ? items[0].name : this.selectTitle
        },
    },

    watch: {
       
        isMobile(newValue) {
        // console.log("🔄 Chuyển sang:", newValue ? "Mobile" : "Desktop");console.log("🔄 Chuyển sang:", newValue ? "Mobile" : "Desktop");
        }
    },

    mounted() {
        
    },
    methods : {
        btnShow(item) {
            this.chooseDiv = false
            // console.log(item.code);
            this.selectedItem = item;
            this.showFullScreen = true
            this.selectDiv = item.code
        
        },
        switchToYard(data) {
            this.chooseDiv = true
            this.blockData = data; // Lưu dữ liệu được truyền từ Block Progress
            this.selectDiv = '1'; // Chuyển sang Block Yard
            this.selectTitle = data.selectTitle;
            // console.log('this.blockData', this.blockData);
            // console.log('this.selectTitle', this.selectTitle);
        }
    }

    
}
</script>
<style >
  .custom-divider {
    border-color: red; /* Đổi màu */
    border-width: 2px; /* Tăng độ dày */
  }

  /* Tạo hiệu ứng hover đẹp hơn */
  .custom-list-item {
    transition: background-color 0.3s;
  }
  .custom-list-item:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
</style>